export default __webpack_public_path__ + "static/media/photo--sm--118.96a564ae.jpg";